<script>

import { getKeyValuePairs, mapDomainDescription } from '@/helpers';
import { DetailList } from '@/components';
import api from '@/api';

export default {
    data() {
        return {
            error: undefined,
            loading: true,
            domainConfig: undefined,
        };
    },
    props: ['clusterName', 'domain'],
    components: {
        'detail-list': DetailList,
    },
    created() {
        this.getDomainInfo();
    },
    methods: {
        async getDomainInfo() {
            const res = await api.getDomainInfo(this.domain);
            this.loading = false;
            if (res.status === 200 && res.data) {
                const r = res.data.response;
                const { clusterName } = this;
                const domainConfig = mapDomainDescription(r);
                const kvps = getKeyValuePairs({ clusterName, item: domainConfig });

                this.domainConfig = { ...domainConfig, kvps };
            } else {
                this.error = '查询domain信息失败！';
            }
        },
    },
};
</script>

<template>
    <section class="domain-settings domain-description" :class="{ loading }">
        <header>
            <h3>{{ domain }}</h3>
        </header>
        <detail-list
            v-if="domainConfig"
            :item="domainConfig"
            :title="`Domain ${domain} Configuration`"
        />
        <span class="error" v-if="error">{{ error }}</span>
    </section>
</template>

<style lang="stylus">
@require "../../styles/definitions.styl"

section.domain-settings.domain-description {
  flex: 1 1 60%;
  padding: layout-spacing-small;

  &.pending dl.details {
    opacity: 0.2;
  }

  span.domain-name {
    display: inline-block;
    font-size: 18px;
    padding: inline-spacing-small;
    font-family: monospace-font-family;
  }

  dl.details {
    & > div {
      display: block;
      padding: inline-spacing-small;
    }

    dt, dd {
      line-height: 1.5em;
    }

    dt {
      text-transform: uppercase;
      font-family: primary-font-family;
      font-weight: 200;
    }
  }
}
</style>
